// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

export const routeNames = {
  termsOfService: createRoutePath("/terms"),
  privacyNotice: createRoutePath("/privacy"),
} as const
